import dayjs, { Dayjs } from 'dayjs';

export const checkExpirationDate = (date: Nullable<Dayjs> | string | undefined): boolean => {
  const today = dayjs().startOf('day');

  const isExpiredDate = dayjs(date).isBefore(today) || dayjs(date).isSame(today);

  return isExpiredDate;
};
